var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.image)?_c('inline-svg',{class:['sunbed-container', _vm.classes],attrs:{"src":_vm.image}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }